import Shared from './components/Shared/Shared.san';
import DatePicker from './components/DatePicker/DatePicker.san';
import Dialoger from './components/Dialoger/Dialoger.san';
import CheckGroups from './components/CheckGroups/CheckGroups.san';
import Workflow from './components/Workflow/Workflow.san';
import ProjectFilters from './components/ProjectFilters/ProjectFilters.san';
import ProjectsList from './components/ProjectsList/ProjectsList.san';
import Light from './components/Light/Light.san';
import Pagination from './components/Pagination/Pagination.san';
import OrganizationTree from './components/OrganizationTree/OrganizationTree.san';
import OrganizationsListTree from './components/OrganizationsListTree/OrganizationsListTree.san';
import ManagersList from './components/ManagersList/ManagersList.san';
import Project from './components/Project/Project.san';
import IssueProjectsList from './components/IssueProjectsList/IssueProjectsList.san';
import IssueProjectsBlock from './components/IssueProjectsBlock/IssueProjectsBlock.san';
import ChangeProjectsList from './components/ChangeProjectsList/ChangeProjectsList.san';
import ChangeProjectsBlock from './components/ChangeProjectsBlock/ChangeProjectsBlock.san';
import SentProjectsList from './components/SentProjectsList/SentProjectsList.san';
import Turn from './components/Turn/Turn.san';
import ReceiveTasks from './components/ReceiveTasks/ReceiveTasks.san';
import RelativeTask from './components/RelativeTask/RelativeTask.san';
import Attachment from './components/Attachment/Attachment.san';
import CopyInfo from './components/CopyInfo/CopyInfo.san';
import Document from './components/Document/Document.san';
import DashboardDoughnut from './components/DashboardDoughnut/DashboardDoughnut.san';
import Dashboard from './components/Dashboard/Dashboard.san';
import DashboardPie from './components/DashboardPie/DashboardPie.san';
import DashboardLine from './components/DashboardLine/DashboardLine.san';
import DashboardBar from './components/DashboardBar/DashboardBar.san';
import UpdatePassword from './components/UpdatePassword/UpdatePassword.san';
import EditProjectAttribute from './components/EditProjectAttribute/EditProjectAttribute.san';
import BatchUpload from './components/BatchUpload/BatchUpload.san';
import About from './components/About/About.san';
import UpdateAuthLicense from './components/UpdateAuthLicense/UpdateAuthLicense.san';
import Schedules from './components/Schedules/Schedules.san';




export default {
    'Shared': Shared,
    'DatePicker': DatePicker,
    'Dialoger': Dialoger,
    'CheckGroups': CheckGroups,
    'Workflow': Workflow,
    'ProjectFilters': ProjectFilters,
    'ProjectsList': ProjectsList,
    'Light': Light,
    'Pagination': Pagination,
    'OrganizationTree': OrganizationTree,
    'OrganizationsListTree': OrganizationsListTree,
    'ManagersList': ManagersList,
    'Project': Project,
    'IssueProjectsList': IssueProjectsList,
    'IssueProjectsBlock': IssueProjectsBlock,
    'ChangeProjectsList': ChangeProjectsList,
    'ChangeProjectsBlock': ChangeProjectsBlock,
    'SentProjectsList': SentProjectsList,
    'Turn': Turn,
    'ReceiveTasks': ReceiveTasks,
    'RelativeTask': RelativeTask,
    'Attachment': Attachment,
    'CopyInfo': CopyInfo,
    'Document': Document,
    'DashboardDoughnut': DashboardDoughnut,
    'Dashboard': Dashboard,
    'DashboardPie': DashboardPie,
    'DashboardLine': DashboardLine,
    'DashboardBar': DashboardBar,
    'UpdatePassword': UpdatePassword,
    'EditProjectAttribute': EditProjectAttribute,
    'BatchUpload': BatchUpload,
    'About': About,
    'UpdateAuthLicense': UpdateAuthLicense,
    'Schedules': Schedules,
};